import { environment } from '@environments/environment';

const ASSETS_IMAGES = '/images/';

/** Path assoluto sotto `images/` per un nome file da environment. */
export function logoAssetPath(filename: string): string {
  return ASSETS_IMAGES + filename;
}

/** Nome file logo header/form in base a tema e viewport (mobile opzionale). */
export function headerLogoFilename(isDark: boolean, isMobile = false): string {
  if (isMobile) {
    return isDark ? environment.LOGO_MOBILE_DARK : environment.LOGO_MOBILE_LIGHT;
  }
  return isDark ? environment.LOGO_HEADER_DARK : environment.LOGO_HEADER_LIGHT;
}

/** Path completo del logo header/form (chiaro/scuro da `data-theme`, file da environment). */
export function headerLogoPath(isDark: boolean, isMobile = false): string {
  return logoAssetPath(headerLogoFilename(isDark, isMobile));
}
